export default "__VITE_ASSET__fab2c395__"